module.exports = __webpack_public_path__ + "static/media/sweepBackground.724cf333.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Sweep/sweepBackground.svg
// module id = 936
// module chunks = 0